import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { useTheme } from '@/lib/theme';
import '@/styles/layout.css';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();

  const isChat = location.pathname === '/chat';

  return (
    <div className="app-layout">
      <header className="app-header">
        <div className="app-header-inner">
          <div className="app-header-logo">
            <img src="/Final-white.png" alt="Zima Media" className="app-header-logo-img" />
          </div>

          <div className="app-header-right">
            {isChat ? (
              <Link to="/account" className="app-header-nav-link">Account</Link>
            ) : user?.plan === 'agent' ? (
              <Link to="/chat" className="app-header-nav-link">Chat</Link>
            ) : null}

            <button
              onClick={toggleTheme}
              className="theme-toggle"
              title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {theme === 'dark' ? (
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="5" />
                  <line x1="12" y1="1" x2="12" y2="3" />
                  <line x1="12" y1="21" x2="12" y2="23" />
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                  <line x1="1" y1="12" x2="3" y2="12" />
                  <line x1="21" y1="12" x2="23" y2="12" />
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                </svg>
              )}
            </button>

            <div className="app-header-user">
              {user?.avatar ? (
                <img
                  src={user.avatar}
                  alt=""
                  className="app-header-avatar"
                  referrerPolicy="no-referrer"
                />
              ) : (
                <div className="app-header-avatar-fallback">
                  {user?.name?.[0] || '?'}
                </div>
              )}
              <span className="app-header-username">{user?.name}</span>
              <a href="/auth/logout" className="app-header-logout" title="Sign out">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </header>
      <div className="app-content">
        {children}
      </div>
    </div>
  );
}
